import object from 'helpers/object'


export const initialState = {
  groups: [],
  members: {},
  isFetching: true,
}


export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setGroups = (state, payload) => (
  object.setIn(state, [ 'groups' ], payload)
)

export const setGroupMembers = (state, payload) => (
  object.setIn(state, [ 'members', payload.groupId ], payload.members)
)
